module.exports = __webpack_public_path__ + "static/media/header_background.1ebed8c4.png";